import { RouteObject } from "react-router-dom";
import MessageActivityLanding from "./landing/landing";
import MessageActivityDetailsLanding from "./details/landing/landing";

export interface uxMessageActivityRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxMessageActivityRoute[];
}

export const uxMessageActivityRoutes: uxMessageActivityRoute[] = [
  {
    path: "communication-hub/message-activity",
    element: <MessageActivityLanding />,
  },
  {
    path: "communication-hub/message-activity/view/:id",
    element: <MessageActivityDetailsLanding />,
  },
];
